import { fetchListingAssets } from '../../../../store/products/fetchListingAssets';
import { fetchVariantAssets } from '../../../../store/products/fetchVariantAssets';
import { PUBLISH_BLOCK_REASONS } from '../../../../helpers/shopify/resolvePublishMedia';

/**
 * Loads listing gallery / draft variant media pools needed for Publish readiness.
 * - needsFetch: load missing pools
 * - thumbnail_processing: refetch pools (revisit / focus fallback for AC7)
 *
 * @param {Object} params
 * @param {Function} params.dispatch
 * @param {string} params.productId
 * @param {Object} params.readiness - selectDraftPublishMediaReadiness result
 * @returns {Promise<void>}
 */
export default async function ensureDraftPublishMediaLoaded({
  dispatch,
  productId,
  readiness,
}) {
  if (!dispatch || !productId || !readiness) return;

  const {
    listingProductId,
    channelId,
    needsFetch,
    missingGallery,
    missingVariants = [],
    draftVariants = [],
    reason,
  } = readiness;

  const isProcessing = reason === PUBLISH_BLOCK_REASONS.THUMBNAIL_PROCESSING;
  if (!needsFetch && !isProcessing) return;
  if (!listingProductId || !channelId) return;

  const tasks = [];

  if (needsFetch ? missingGallery : true) {
    tasks.push(
      dispatch(fetchListingAssets({
        masterProductId: productId,
        channelId,
        listingProductId,
      })).unwrap().catch(() => {}),
    );
  }

  const variantsToFetch = needsFetch ? missingVariants : draftVariants;
  variantsToFetch.forEach(({ listingVariantId, masterVariantId }) => {
    tasks.push(
      dispatch(fetchVariantAssets({
        variantId: listingVariantId,
        productId,
        channelId,
        masterVariantId,
      })).unwrap().catch(() => {}),
    );
  });

  if (tasks.length) {
    await Promise.all(tasks);
  }
}
